var styles = {"input":"styles_input__QfNu9","errored":"styles_errored__cIvAU","dark":"styles_dark__3XikI"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
